import React, { FC } from 'react';
import s from './ContextMenu.module.css';

interface ContextMenuProps {
    children: React.ReactNode;
    position: { x: number; y: number };
    isOpen: boolean;
}

const ContextMenu: FC<ContextMenuProps> = ({ children, position, isOpen }) => {
    if (!isOpen) return null;

    return (
        <div
            className={s.contextMenu}
            style={{ top: position.y, left: position.x }}
        >
            {children}
        </div>
    );
};

export default ContextMenu;
